import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { VarificationService } from 'src/app/services/core/varifications/varification.service';
import { onTimeChange } from 'src/app/utils/utils.common';
import { driverVerificationLabels } from 'src/app/utils/utils.common';
import { scrollToDocumentField } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { sweetAlert } from 'src/app/utils/swal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
@UntilDestroy()

@Component({
  selector: 'app-driver-verification-slideout',
  templateUrl: './driver-verification-slideout.component.html',
  styleUrls: ['./driver-verification-slideout.component.css']
})
export class DriverVerificationSlideoutComponent implements OnInit {
  submitted = false;
  driverFrom!: FormGroup;
  driverVarificationForm!: FormGroup
  approvalForm!: FormGroup;
  @Input() driverObj: any;
  @Input() scrollToField: any;
  @Input() highlightStatus: any;
  @Output() closeModal = new EventEmitter<any>
  users: any;
  driverData: any;
  isAllControlsTrue: boolean = false;
  serviceAreaName:any = [];
  showRejectReasonModal = false;
  rejectingDocumentLabel: string = '';
  rejectingSection: string = '';
  rejectingField: string = '';
  rejectingControlPath: string = '';
  rejectingGroupName: string = '';
  rejectingControlName: string = '';
  rejectedReasons: { [key: string]: string } = {};
  sectionLabels: { [key: string]: string } = {
    driverLicense: 'driversDocuments',
    examinations: 'driversDocuments',
  };
  fieldGroupMap: { [key: string]: string } = {
    image: 'driverLicense',
    number: 'driverLicense',
    issueDate: 'driverLicense',
    expireDate: 'driverLicense',
    stateIssue: 'driverLicense',
    attestation: '',
    phyExamImage: 'examinations',
    phyExamDate: 'examinations',
    phyExamExpireDate: 'examinations',
    drugTestImage: 'examinations',
    drugTestDate: 'examinations',
    drugTestExpireDate: 'examinations',
  };

  constructor(
    private userService: UserService,
    private varificationSerice: VarificationService,
    private cedentialService: CredentialService,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.driverFrom = this.fb.group({
      firstName: ['',],
      middleName: ['',],
      lastName: [''],
      displayName: [''],
      address: this.fb.group({
        name: [''],
        coords: [''],
        city: [''],
        state: [''],
      }),
      phoneNumber: [''],
      contactNumber: [''],
      email: [''],
      profileImageURL: [''],
      signature: [''],
            dob: [''],
      languageSpoken: [''],

      driverLicense: this.fb.group({
        image: ['',],
        number: [''],
        issueDate: ['',],
        expireDate: ['',],
        stateIssue: [''],
      }),
      examinations: this.fb.group({
        phyExamImage: [''],
        phyExamDate: [''],
        phyExamExpireDate: [''],
        drugTestImage: [''],
        drugTestDate: ['',],
        drugTestExpireDate: ['',],
      }),
      abuse: [false],
      violations: [false],
      serviceAreas: [[],],
      attestation: [''],
    })

    this.driverVarificationForm = this.fb.group({
      isFirstName: [false],
      isMiddleName: [false],
      isLastName: [false],
      isDisplayName: [false],
      isProfileImageURL: [false],
      isSignature: [false],
      isPhoneNumber: [false],
      isContactNumber: [false],
      isEmail: [false],
      isDob: [false],
      isLanguageSpoken: [false],
      address: this.fb.group({
        isName: [false],
        isCity: [false],
        isState: [false],
      }),
      driverLicense: this.fb.group({
        isImage: [false],
        isNumber: [false],
        isIssueDate: [false],
        isExpireDate: [false],
        isStateIssue: [false],
      }),
      examinations: this.fb.group({
        isPhyExamImage: [false],
        isPhyExamDate: [false],
        isPhyExamExpireDate: [false],
        isDrugTestImage: [false],
        isDrugTestDate: [false],
        isDrugTestExpireDate: [false],
      }),
      isAbuse: [false],
      isViolations: [false],
      isServiceAreas: [false],
      isAttestation: [false],
    });

    this.approvalForm = this.fb.group({
      isApproved: [false, Validators.required],
      approvedDate: ['', Validators.required],
      user: ['', Validators.required],
    })
    this.getUser();
    this.getDriverById();
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this)).subscribe(user => {
      if (user) {
        this.approvalForm.patchValue({
          user: user.id
        });
      }
    });
  }

  getDriverById() {
    this.cedentialService.getDriverById(this.driverObj.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.driverData = data;
        this.rejectedReasons = this.showRejectReason(data.rejectionReasons);
        if(this.driverData.serviceAreas){
          this.serviceAreaName.push(...this.driverData.serviceAreas.split(',').map((area:any) => area.trim()));
        }
        this.patchValuesToForm(data)
        if (this.scrollToField) {
          scrollToDocumentField(this.scrollToField, 300, true, this.highlightStatus);
        }
      }
    })
  }

  toggleDisApprovedReasonModal(show: boolean, documentLabel: string = '', groupName: string = '', controlName: string = '', section: string = '') {
    this.showRejectReasonModal = show;
    this.rejectingDocumentLabel = documentLabel;
    if (controlName) {
      const rawField = controlName.replace(/^is/, '');
      this.rejectingField = rawField.charAt(0).toLowerCase() + rawField.slice(1);
      this.rejectingSection = section || (this.sectionLabels[groupName] ?? groupName);
      this.rejectingControlPath = groupName ? `${groupName}.${controlName}` : controlName;
      this.rejectingGroupName = groupName;
      this.rejectingControlName = controlName;
    }
  }

  onRejectReasonSubmit(reason: string) {
    if (!this.driverData) {
      return;
    }
    const payload = {
      section: this.rejectingSection,
      field: this.rejectingField,
      approved: false,
      reason,
    };
    this.varificationSerice.disApprovedDriverField(this.driverObj.id, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.setControl(this.driverVarificationForm.get(this.rejectingControlPath) as AbstractControl, false);
        this.rejectedReasons[this.rejectingControlPath] = reason;
        this.toggleDisApprovedReasonModal(false);
      }
    });
  }

  approveField(groupName: string, controlName: string, section: string = '') {
    if (!this.driverData) {
      return;
    }
    const rawField = controlName.replace(/^is/, '');
    const payload = {
      section: section || (this.sectionLabels[groupName] ?? groupName),
      field: rawField.charAt(0).toLowerCase() + rawField.slice(1),
      approved: true,
      reason: '',
    };
    const path = groupName ? `${groupName}.${controlName}` : controlName;
    this.varificationSerice.disApprovedDriverField(this.driverObj.id, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.setControl(this.driverVarificationForm.get(path) as AbstractControl, true);
        delete this.rejectedReasons[path];
      }
    });
  }

  showRejectReason(rejectionReasons: any): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    if (!rejectionReasons) {
      return result;
    }
    Object.keys(rejectionReasons).forEach((group) => {
      const fields = rejectionReasons[group] || {};
      Object.keys(fields).forEach((field) => {
        const controlName = 'is' + field.charAt(0).toUpperCase() + field.slice(1);
        const subGroup = this.fieldGroupMap[field] ?? group;
        const path = subGroup ? `${subGroup}.${controlName}` : controlName;
        result[path] = fields[field]?.reason;
      });
    });
    return result;
  }


  checkNonValidFields() {
    const nonValidFields: string[] = [];
  
    const traverse = (obj: { [x: string]: any; }, path = "") => {
      for (const key in obj) {
        const value = obj[key];
        const currentPath = path ? `${path}.${key}` : key;
  
        if (!value) {
          nonValidFields.push(currentPath); // Store the full path of the invalid field
        }
  
        if (typeof value === "object" && value !== null) {
          traverse(value, currentPath); // Recurse for nested objects
        }
      }
    };
  
    traverse(this.driverData.validationFlags);
    traverse(this.driverVarificationForm.value);
  
    return nonValidFields;
  }
  

  onCloseModal() {
    this.closeModal.emit();
  }

  onSave() {
    // this.submitted = true

    if (this.driverVarificationForm.invalid) {
      return;
    }
    const payload = this.driverVarificationForm.value;
    this.varificationSerice.verifyDriver(this.driverObj.id, payload).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.driverData = data;
        this.patchValuesToForm(data)
        // this.onCloseModal();
      }
    })


  }

  onApproval() {
    this.submitted = true
    const isCurrentlyApproved = this.driverData?.isApproved;
    if (this.checkNonValidFields().length && !isCurrentlyApproved) {
      sweetAlert('Alert', `Some fields are missing.`, 'warning', 'OK')
      return;
    }
    const newApprovalState = !isCurrentlyApproved;
    if (this.approvalForm.invalid) {
      return;
    }

    this.approvalForm.patchValue({
      isApproved: newApprovalState
    })

    const payload = this.approvalForm.value;
    this.varificationSerice.approvedDriver(this.driverObj.id, payload).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.driverData = data;
        this.patchValuesToForm(data)
       this.closeModal.emit(data);
        // this.onCloseModal();
      }
    })
  }

  setControl(control: AbstractControl, value: any): void {
    if (control) {
      control.setValue(value);
    }
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  // Getter for form controls
  get form(): any {
    return this.driverVarificationForm.controls;
  }
  get address(): any {
    return this.driverVarificationForm.get('address') as FormGroup;
  }

  get driverLicense(): any {
    return this.driverVarificationForm.get('driverLicense') as FormGroup;
  }

  get examinations(): any {
    return this.driverVarificationForm.get('examinations') as FormGroup;
  }

  get approveForm() {
    return this.approvalForm.controls;
  }


  patchValuesToForm(data: any) {
    this.rejectedReasons = this.showRejectReason(data.rejectionReasons);
    this.driverFrom.patchValue({
      ...data,
      abuse : data.abuse ? 'Yes' : 'No',
      violations : data.violations ? 'Yes' : 'No',
      dob: moment(data?.dob).format('MM/DD/YYYY'),
      driverLicense: {
        ...data.driverLicense,
        issueDate: data?.driverLicense?.issueDate ? moment(data?.driverLicense?.issueDate).format('MM/DD/YYYY') : '',
        expireDate: data?.driverLicense?.expireDate ? moment(data?.driverLicense?.expireDate).format('MM/DD/YYYY') : '',
      },
      examinations: {
        ...data.examinations,
        phyExamDate: data?.examinations?.phyExamDate ? moment(data?.examinations?.phyExamDate).format('MM/DD/YYYY') : '',
        phyExamExpireDate: data?.examinations?.phyExamExpireDate ? moment(data?.examinations?.phyExamExpireDate).format('MM/DD/YYYY') : '',
        drugTestDate: data?.examinations?.drugTestDate ? moment(data?.examinations?.drugTestDate).format('MM/DD/YYYY') : '',
        drugTestExpireDate: data?.examinations?.drugTestExpireDate ? moment(data?.examinations?.drugTestExpireDate).format('MM/DD/YYYY') : '',
      }
    });  

    this.approvalForm.patchValue(data);  
    this.driverVarificationForm.patchValue({
      ...data.validationFlags
    })
  }

   getInvalidFields(): string[] {
      const formValues = this.driverVarificationForm.value;
      const labels: string[] = [];
      this.traverseForm(formValues, driverVerificationLabels, labels);
      return labels;
    }

    traverseForm(values: any, labelMap: any, labels: string[], prefix: string = ''): void {
      Object.keys(values).forEach(key => {
        if (typeof values[key] === 'object' && values[key] !== null) {
          // Check if labelMap[key] is an object, recursively call the function
          if (typeof labelMap[key] === 'object') {
            this.traverseForm(values[key], labelMap[key], labels, prefix);
          } else {
            this.traverseForm(values[key], labelMap[key], labels, prefix + labelMap[key] + ' - ');
          }
        } else if (values[key] === false) {
          labels.push(prefix + (labelMap[key] || key));
        }
      });
    }

    sendInvalidFieldsViaEmail(): void {
      const invalidFields = this.getInvalidFields();
      if (invalidFields.length > 0) {
        this.varificationSerice.driverInformationViaEmail(this.driverObj.id, invalidFields).pipe(untilDestroyed(this)).subscribe((data: any) => {
          if (data) {
            this.onCloseModal()
          }
        })
      }
  
    }

}

